import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col gap-2", className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "flex h-10 items-end bg-transparent p-0 text-muted-foreground overflow-hidden",
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
      // Base styles
      "relative inline-flex items-center justify-center whitespace-nowrap px-4 py-2 text-sm truncate font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      // Chrome tab shape using clip-path
      "w-48 max-w-[240px] h-8 mx-0 rounded-t-2xl bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300",
      // Active state
      "data-[state=active]:bg-white dark:data-[state=active]:bg-gray-900 data-[state=active]:text-foreground data-[state=active]:shadow-sm data-[state=active]:z-10",
      // Hover state
      "hover:bg-gray-300 dark:hover:bg-gray-600 data-[state=active]:hover:bg-white dark:data-[state=active]:hover:bg-gray-900",
      // Chrome tab trapezoid shape
      "before:absolute before:inset-0 before:rounded-t-lg",
      "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:bg-border data-[state=active]:after:bg-transparent",
      // Overlap effect
      "-ml-px first:ml-0",
        className
      )}
      {...props}
    />
  )
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("flex-1 outline-none", className)}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
